import React from "react";
import { GridLayout } from "./layout";
import StatsObj from "./StatsObj";
import { TitleAtom } from "../atoms/titleAtom";
import { Title } from "chart.js";
import { padding } from "polished";

export default function ProfileStats({ stats }) {
  console.log("User Stats:", stats);
  return (
    <>
     <TitleAtom className="standard-padding profile-sub-title" title="Statistieken" />
      <GridLayout className="not-clickable stats-grid" gap="1rem" columnsTemplate="repeat(4, 1fr)" style={{ padding: "0 1.5rem" }}>
        <StatsObj
            BackgroundColor={"var(--primary-50)"}
            color={"var(--primary-500)"}
            title={"Cursussen gestart"}
            icon2={"school"}
            value={stats.started_courses || 0}
          />
        <StatsObj
            BackgroundColor={"var(--success-50)"}
            color={"var(--success-500)"}
            title={"Cursussen voltooid"}
            icon2={"check-circle"}
            value={stats.finished_courses || 0}
          />
        <StatsObj
            BackgroundColor={"var(--warning-50)"}
            color={"var(--warning-500)"}
            title={"Lopende cursussen"}
            icon2={"bezig"}
            value={stats.not_finished_courses || 0}
          />
        <StatsObj
            BackgroundColor={"var(--purple-50)"}
            color={"var(--purple-500)"}
            title={"Skills verworven"}
            icon2={"certificate"}
            value={stats.totaal_skills || 0}
          />
      </GridLayout>
   
    </>
  );
}
